export default "__VITE_ASSET__P_1Mqtq6__"